/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partnerscolumnmenuscans3Inputs */

const en_partnerscolumnmenuscans3 = /** @type {(inputs: Partnerscolumnmenuscans3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menus read in`)
};

const de_partnerscolumnmenuscans3 = /** @type {(inputs: Partnerscolumnmenuscans3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menüs eingelesen`)
};

/**
* | output |
* | --- |
* | "Menus read in" |
*
* @param {Partnerscolumnmenuscans3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const partnerscolumnmenuscans3 = /** @type {((inputs?: Partnerscolumnmenuscans3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partnerscolumnmenuscans3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_partnerscolumnmenuscans3(inputs)
	return de_partnerscolumnmenuscans3(inputs)
});
export { partnerscolumnmenuscans3 as "partnersColumnMenuScans" }